// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2duUT","actionsCol":"EnrolledClinics_actionsCol__7pxE2"};